import styled from 'styled-components';

export default styled.div`
  position: fixed;
  z-index: 2000;
  inset: 0;
`;
